import { render } from "./CustomHeadToHeadResults.vue?vue&type=template&id=ebfd538c&scoped=true"
import script from "./CustomHeadToHeadResults.vue?vue&type=script&lang=js"
export * from "./CustomHeadToHeadResults.vue?vue&type=script&lang=js"

import "./CustomHeadToHeadResults.vue?vue&type=style&index=0&id=ebfd538c&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/oztagaustralia-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebfd538c"]])

export default __exports__